import { c as _c } from "react/compiler-runtime";
import { QueryCache, QueryClient, type QueryKey, useQuery, type UseQueryOptions } from '@tanstack/react-query';
import { ToastType } from '@shared/ui-components/toast/constants/constants';
import { useGlobalToastContext } from '@shared/ui-components/toast/context/global-toast-context';
import { useGlobalCmsContentContext } from '../../components/providers/global-cms-context';

/**
 * @deprecated Use `useQuery` with custom hook for each new endpoint instead (e.g. useMemberDirectorySearchQuery).
 */
export const useQueryHandler = options => {
  const $ = _c(3);
  const {
    addToast
  } = useGlobalToastContext();
  const {
    cmsContent
  } = useGlobalCmsContentContext();
  let t0;
  if ($[0] !== addToast || $[1] !== cmsContent) {
    t0 = new QueryClient({
      queryCache: new QueryCache({
        onError: () => {
          addToast({
            closeButtonLabel: cmsContent.closeButtonLabel,
            description: cmsContent.somethingWentWrong,
            type: ToastType.ERROR
          }, {
            timeout: 0
          });
        }
      })
    });
    $[0] = addToast;
    $[1] = cmsContent;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const queryClient = t0;
  return useQuery(options, queryClient);
};